export default "__VITE_ASSET__Bfk2qt6y__"